
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import VarietyDetailApi from '@/app/model/api/varietyDetailApi'
import VarietyCreateApi from '@/app/model/api/varietyCreateApi'
import VarietyEditApi from '@/app/model/api/varietyEditApi'
import VarietyDeleteApi from '@/app/model/api/varietyDeleteApi'
import AiAdviceApi from '@/app/model/api/aiAdviceApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import DviValidator from '@/app/module/dviValidator'
import Local from '@/app/module/local'
import Session from '@/app/module/session'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Error409Modal,
    Loading,
    ErrorInfo,
    ConfirmModal
  }
})
export default class VarietyCreate extends Vue {
  private stageIsVaildFlags: any = []
  private constantValue: any = []
  private errorMessages: any = {}
  private alertText: string = ''
  private alertTitle: string = ''
  private confirmMessage: string = '<p>生育ステージの「利用する」を変更している場合は<br/>関連する品種生育マスタの生育ステージの有効/無効も変更されます。<br/>よろしいですか？</p>'
  private aiAdvice: any = []
  private dviValueSelected: any = [
    { text: 'なし', value: 0 },
    { text: 'あり', value: 1 }
  ]
  private saveData: any = {}
  private varietyData: any = {
    variety: {
      variety_name: '',
      remarks: '',
      is_dvi: 0,
      ai_advice_id: null
    },
    dvi: {
      dvi_a_1: null,
      dvi_th_1: null,
      dvi_g_1: null,
      dvi_b_1: null,
      dvi_a_2: null,
      dvi_th_2: null,
      dvi_g_2: null,
      dvi_b_2: null,
      ideal_water_level_0_9: null,
      ideal_water_level_1_0: null,
      ideal_water_level_1_1: null,
      ideal_water_level_1_2: null,
      ideal_water_level_1_3: null,
      ideal_water_level_1_4: null,
      ideal_water_level_1_5: null,
      ideal_water_level_1_6: null,
      ideal_water_level_1_7: null,
      ideal_water_level_1_8: null,
      ideal_water_level_1_9: null,
      ideal_water_level_2_0: null
    },
    variety_stages: []
  }
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private isEdit: boolean = false
  private isError: any = {}
  private isDisable: any = {}
  private showError409Modal: boolean = false
  private showSaveVerifyModal: boolean = false
  private copyFlag: boolean = false
  private show400ErrorMessage: boolean = false

  private get route (): any {
    return this.$route.path
  }
  @Watch('route')
  getRoute (route: string) {
    if (this.copyFlag && route === '/master/variety/create') {
      location.reload()
    }
  }

  created () {
    // システム定義情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    // AIアドバイス取得
    this.getAiAdvice()

    if (this.$route.path === '/master/variety/create') {
      this.isEdit = false

      // コピーがあれば表示、なければデフォルト表示
      const copyData = JSON.parse(Session.getCopyVarietyData()!)
      if (copyData === undefined || copyData === null) {
        this.stageIsVaildFlags = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        // システム定義を使ってステージ配列を作成
        for (let j in this.constantValue.sys_variety_stages) {
          let isValid
          if (this.constantValue.sys_variety_stages[j].sys_variety_stage_id === 1 ||
              this.constantValue.sys_variety_stages[j].sys_variety_stage_id === 11) {
            isValid = 1
          } else {
            isValid = 0
          }
          this.varietyData.variety_stages.push({
            step: this.constantValue.sys_variety_stages[j].sys_variety_stage_id,
            is_valid: isValid,
            stage_name: this.constantValue.sys_variety_stages[j].variety_stage_name,
            water_level_upper_limit: null,
            water_level_lower_limit: null,
            water_temp_upper_limit: null,
            water_temp_lower_limit: null
          })
        }
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          const data = this.varietyData.variety_stages[i]
          if (this.stageIsVaildFlags.includes(data.step)) {
            this.$set(this.isDisable, 'is_valid' + data.step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + data.step, true)
          }
        }
      } else {
        this.varietyData = copyData
        // 品種名に（コピー）と表示
        this.varietyData.variety.variety_name = this.varietyData.variety.variety_name + '（コピー）'
        sessionStorage.removeItem('varietyCopyData')
        this.varietyData.dvi = this.transformKeys(this.varietyData.dvi)
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          if (this.varietyData.variety_stages[i].is_valid === 1) {
            this.stageIsVaildFlags.push(this.varietyData.variety_stages[i].step)
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, true)
          }
        }
      }
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getVarietyList()
    }
  }

  private transformKeys = (obj: any) => {
    let result: any = {}
    Object.keys(obj).forEach(x => {
      var y = x.replace('.', '_')
      result[y] = obj[x]
    })
    return result
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string, key3: string) {
    let before
    if (key1 === 'dvi') {
      before = String(this.varietyData[key1][key3])
    } else {
      before = String(this.varietyData[key1][key2][key3])
    }

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    // 小数点以下OK
    if (key1 === 'dvi') {
      if (isNaN(parseFloat(after))) {
        this.varietyData[key1][key3] = null
      } else {
        this.varietyData[key1][key3] = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.varietyData[key1][key2][key3] = null
      } else {
        this.varietyData[key1][key2][key3] = parseFloat(after)
      }
    }
  }

  // AIアドバイス取得
  private getAiAdvice () {
    (async () => {
      const result = await AiAdviceApi.getAiAdvice({
        word: '',
        order_name: 'name',
        sort: 'asc'
      })

      if (result.isOk()) {
        this.aiAdvice = result.getPayload().ai_advice
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private getVarietyList () {
    (async () => {
      const result = await VarietyDetailApi.getVarietyDetail(this.$route.params.variety_id)
      if (result.isOk()) {
        this.varietyData = result.getPayload()
        this.varietyData.dvi = this.transformKeys(this.varietyData.dvi)
        // DVI値ありなし
        if (this.varietyData.variety.is_dvi === 'なし') {
          this.varietyData.variety.is_dvi = 0
        } else {
          this.varietyData.variety.is_dvi = 1
        }
        // ステージ利用可否設定
        for (let i in this.varietyData.variety_stages) {
          if (this.varietyData.variety_stages[i].is_valid === 1) {
            this.stageIsVaildFlags.push(this.varietyData.variety_stages[i].step)
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, false)
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyData.variety_stages[i].step, true)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isvarietyCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    this.saveData = {
      variety: this.varietyData.variety,
      dvi: {
        dvi_a_1: this.varietyData.dvi.dvi_a_1,
        dvi_th_1: this.varietyData.dvi.dvi_th_1,
        dvi_g_1: this.varietyData.dvi.dvi_g_1,
        dvi_b_1: this.varietyData.dvi.dvi_b_1,
        dvi_a_2: this.varietyData.dvi.dvi_a_2,
        dvi_th_2: this.varietyData.dvi.dvi_th_2,
        dvi_g_2: this.varietyData.dvi.dvi_g_2,
        dvi_b_2: this.varietyData.dvi.dvi_b_2,
        'ideal_water_level_0.9': this.varietyData.dvi.ideal_water_level_0_9,
        'ideal_water_level_1.0': this.varietyData.dvi.ideal_water_level_1_0,
        'ideal_water_level_1.1': this.varietyData.dvi.ideal_water_level_1_1,
        'ideal_water_level_1.2': this.varietyData.dvi.ideal_water_level_1_2,
        'ideal_water_level_1.3': this.varietyData.dvi.ideal_water_level_1_3,
        'ideal_water_level_1.4': this.varietyData.dvi.ideal_water_level_1_4,
        'ideal_water_level_1.5': this.varietyData.dvi.ideal_water_level_1_5,
        'ideal_water_level_1.6': this.varietyData.dvi.ideal_water_level_1_6,
        'ideal_water_level_1.7': this.varietyData.dvi.ideal_water_level_1_7,
        'ideal_water_level_1.8': this.varietyData.dvi.ideal_water_level_1_8,
        'ideal_water_level_1.9': this.varietyData.dvi.ideal_water_level_1_9,
        'ideal_water_level_2.0': this.varietyData.dvi.ideal_water_level_2_0
      },
      variety_stages: this.varietyData.variety_stages
    }

    if (this.isEdit) {
      this.showSaveVerifyModal = true
    } else {
      this.showLoading = true
      this.varietyCreate()
    }
  }

  private async varietyCreate () {
    const result = await VarietyCreateApi.doVarietyCreate(this.saveData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async varietyEdit () {
    this.showLoading = true
    const result = await VarietyEditApi.doVarietyEdit(this.$route.params.variety_id, this.saveData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
    this.showSaveVerifyModal = false
  }

  private changeValid (step: number) {
    // ステージ利用可否設定
    if (this.stageIsVaildFlags.includes(step)) {
      this.$set(this.isDisable, 'is_valid' + step, false)
    } else {
      this.$set(this.isDisable, 'is_valid' + step, true)
    }
  }

  private isvarietyCreate () {
    for (let i in this.errorMessages) {
      this.errorMessages[i] = ''
    }
    const varietyNameFlag = Validator.validateInputVarietyName('varietyNameErrorMessage', this.varietyData.variety.variety_name)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    for (let i in this.varietyData.variety_stages) {
      const data = this.varietyData.variety_stages[i]
      // ステージ利用可否設定
      if (this.stageIsVaildFlags.includes(data.step)) {
        data.is_valid = 1
      } else {
        data.is_valid = 0
      }
      // ステージ名バリデーション
      if (data.stage_name === '' && data.is_valid === 1) {
        this.$set(this.errorMessages, 'varietyStageNameErrorMessage', 'ステージ名は必ず入力してください')
        isError = false
        this.$set(this.isError, 'stage_name' + i, true)
      } else {
        this.$set(this.isError, 'stage_name' + i, false)
      }
      // 水位上限バリデーション
      if (data.water_level_upper_limit !== null) {
        if (data.water_level_upper_limit < 0 || data.water_level_upper_limit > 100) {
          this.$set(this.errorMessages, 'varietyWaterLevelErrorMessage', '水位閾値は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_level_upper_limit' + i, true)
        } else if (!Number.isInteger(data.water_level_upper_limit)) {
          this.$set(this.errorMessages, 'varietyWaterLevelErrorMessage', '水位閾値は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'water_level_upper_limit' + i, true)
        } else {
          this.$set(this.isError, 'water_level_upper_limit' + i, false)
        }
      } else {
        this.$set(this.isError, 'water_level_upper_limit' + i, false)
      }
      // 水位下限バリデーション
      if (data.water_level_lower_limit !== null) {
        if (data.water_level_lower_limit < 0 || data.water_level_lower_limit > 100) {
          this.$set(this.errorMessages, 'varietyWaterLevelErrorMessage', '水位閾値は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_level_lower_limit' + i, true)
        } else if (!Number.isInteger(data.water_level_lower_limit)) {
          this.$set(this.errorMessages, 'varietyWaterLevelErrorMessage', '水位閾値は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'water_level_lower_limit' + i, true)
        } else {
          this.$set(this.isError, 'water_level_lower_limit' + i, false)
        }
      } else {
        this.$set(this.isError, 'water_level_lower_limit' + i, false)
      }
      // 水温上限バリデーション
      if (data.water_temp_upper_limit !== null) {
        let decimalPointLength = String(data.water_temp_upper_limit).split('.')
        if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
          this.$set(this.errorMessages, 'varietyWaterTempErrorMessage', '水温閾値は小数点第1位までの範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_temp_upper_limit' + i, true)
        } else if (data.water_temp_upper_limit < 0 || data.water_temp_upper_limit > 100) {
          this.$set(this.errorMessages, 'varietyWaterTempErrorMessage', '水温閾値は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_temp_upper_limit' + i, true)
        } else {
          this.$set(this.isError, 'water_temp_upper_limit' + i, false)
        }
      } else {
        this.$set(this.isError, 'water_temp_upper_limit' + i, false)
      }
      // 水温下限バリデーション
      if (data.water_temp_lower_limit !== null) {
        let decimalPointLength = String(data.water_temp_lower_limit).split('.')
        if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
          this.$set(this.errorMessages, 'varietyWaterTempErrorMessage', '水温閾値は小数点第1位までの範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_temp_lower_limit' + i, true)
        } else if (data.water_temp_lower_limit < 0 || data.water_temp_lower_limit > 100) {
          this.$set(this.errorMessages, 'varietyWaterTempErrorMessage', '水温閾値は0以上100以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_temp_lower_limit' + i, true)
        } else {
          this.$set(this.isError, 'water_temp_lower_limit' + i, false)
        }
      } else {
        this.$set(this.isError, 'water_temp_lower_limit' + i, false)
      }
    }

    let isRequiredDviParam = true
    let isRequiredIdealWaterLevel = true
    if (this.varietyData.variety.is_dvi === 1) {
      let errorMessage = null
      if (this.varietyData.dvi.dvi_a_1 === null ||
        this.varietyData.dvi.dvi_th_1 === null ||
        this.varietyData.dvi.dvi_g_1 === null ||
        this.varietyData.dvi.dvi_b_1 === null ||
        this.varietyData.dvi.dvi_a_2 === null ||
        this.varietyData.dvi.dvi_th_2 === null ||
        this.varietyData.dvi.dvi_g_2 === null ||
        this.varietyData.dvi.dvi_b_2 === null) {
        isRequiredDviParam = DviValidator.validRequiredDviParam('dviParamErrorMessage', '')
        errorMessage = Object.assign({}, errorMessage, DviValidator.getErrorMessage())
      }

      if (this.varietyData.dvi.ideal_water_level_0_9 === null ||
        this.varietyData.dvi.ideal_water_level_1_0 === null ||
        this.varietyData.dvi.ideal_water_level_1_1 === null ||
        this.varietyData.dvi.ideal_water_level_1_2 === null ||
        this.varietyData.dvi.ideal_water_level_1_3 === null ||
        this.varietyData.dvi.ideal_water_level_1_4 === null ||
        this.varietyData.dvi.ideal_water_level_1_5 === null ||
        this.varietyData.dvi.ideal_water_level_1_6 === null ||
        this.varietyData.dvi.ideal_water_level_1_7 === null ||
        this.varietyData.dvi.ideal_water_level_1_8 === null ||
        this.varietyData.dvi.ideal_water_level_1_9 === null ||
        this.varietyData.dvi.ideal_water_level_2_0 === null) {
        isRequiredIdealWaterLevel = DviValidator.validRequiredIdealWaterLevel('idealWaterLevelErrorMessage', '')
        errorMessage = Object.assign({}, errorMessage, DviValidator.getErrorMessage())
      }

      if (errorMessage !== null && this.errorMessages !== '') {
        this.errorMessages = Object.assign({}, this.errorMessages, errorMessage)
      }
    }
    for (let i in this.varietyData.dvi) {
      const data = this.varietyData.dvi[i]

      if (i.indexOf('dvi') === 0) {
        if (data !== null) {
          let decimalPointLength = String(data).split('.')
          if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 4) {
            this.$set(this.errorMessages, 'varietyDviErrorMessage', 'DVIは小数点第4位までの範囲で入力してください。')
            isError = false
            this.$set(this.isError, i, true)
          } else if (data < 0 || data > 100) {
            this.$set(this.errorMessages, 'varietyDviErrorMessage', 'DVIは0以上100以下の範囲で入力してください。')
            isError = false
            this.$set(this.isError, i, true)
          } else {
            this.$set(this.isError, i, false)
          }
        } else {
          this.$set(this.isError, i, false)
        }
      } else {
        if (data !== null) {
          if (data < 0 || data > 100) {
            this.$set(this.errorMessages, 'varietyIdealDviErrorMessage', '理想水位は0以上100以下の範囲で入力してください。')
            isError = false
            this.$set(this.isError, i, true)
          } else if (!Number.isInteger(data)) {
            this.$set(this.errorMessages, 'varietyIdealDviErrorMessage', '理想水位は整数で入力してください。')
            isError = false
            this.$set(this.isError, i, true)
          } else {
            this.$set(this.isError, i, false)
          }
        } else {
          this.$set(this.isError, i, false)
        }
      }
    }

    return isRequiredDviParam && isRequiredIdealWaterLevel && varietyNameFlag && isError
  }

  private doVarietyDelete () {
    (async () => {
      this.showLoading = true
      const result = await VarietyDeleteApi.doVarietyDelete(this.$route.params.variety_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/variety').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private createCopy () {
    Session.setCopyVarietyData(JSON.stringify(this.varietyData))
    this.copyFlag = true
    this.$router.push('/master/variety/create').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/master/variety').catch(e => {})
  }
}
